<template>
    <div class="row card-body" style="padding-top: 0px;padding-bottom: 5em;" id="editColorTheme">
        <div class="card-header window-header" style="margin: 0px -10px 0px -10px; width: 105%;">
            <h4>{{ lang.ect_color_theme }}</h4>
        </div>
        <div class="window-body">
            <div class="row" v-if="isLoading">
                <div class="col-md-12">
                    <div class="loadingImg">
                        <Loader></Loader>
                    </div>
                </div>
            </div>
            <form v-else class="row" @submit.prevent="submitColorTheme">
                <!-- Selector principal de tipo de fondo -->
                <div class="col-md-6 marginTop">
                    <label class="col-form-label">{{ lang.ect_bg_type }}</label>
                    <div class="typeSelector">
                        <label class="typeOption">
                            <input type="radio" value="color" v-model="bg_template.type" @change="onTypeChange" />
                            {{ lang.ect_color }}
                        </label>
                        <label class="typeOption">
                            <input type="radio" value="gradient" v-model="bg_template.type" @change="onTypeChange" />
                            {{ lang.ect_gradient }}
                        </label>
                        <label class="typeOption">
                            <input type="radio" value="image" v-model="bg_template.type" @change="onTypeChange" disabled/>
                            {{ lang.ect_image }} <small>{{ lang.ect_inactive }}</small>
                        </label>
                    </div>
                </div>
                <div class="col-md-6 marginTop">
                <!-- Intro: explica el objetivo del editor y los tipos soportados -->
                    <p>
                        {{ lang.ect_bg_desc }}
                    </p>
                </div>

                <!-- Modo color: un solo valor RGBA -->
                <div class="col-md-12 " v-if="bg_template.type === 'color'">
                    <label class="col-form-label">{{ lang.ect_bg_color }}</label>
                    <input type="text" class="form-control" :value="bg_template.value" readonly />
                    <chrome-picker class="picker" :value="colorPicker" @input="onSingleColorInput"></chrome-picker>
                </div>

                <!-- Modo gradient: exactamente 2 colores RGBA -->
                <template v-if="bg_template.type === 'gradient'">
                    <div class="col-md-6 ">
                        <label class="col-form-label">{{ lang.ect_gradient_1 }}</label>
                        <input type="text" class="form-control" :value="bg_template.value[0]" readonly />
                        <chrome-picker class="picker" :value="gradientPickerStart" @input="onGradientStartInput"></chrome-picker>
                    </div>
                    <div class="col-md-6 ">
                        <label class="col-form-label">{{ lang.ect_gradient_2 }}</label>
                        <input type="text" class="form-control" :value="bg_template.value[1]" readonly />
                        <chrome-picker class="picker" :value="gradientPickerEnd" @input="onGradientEndInput"></chrome-picker>
                    </div>
                </template>

                <!-- Modo image: se valida extensión/tipo MIME y se muestra preview local -->
                <div class="col-md-12 " v-if="bg_template.type === 'image'">
                    <label class="col-form-label">{{ lang.ect_bg_image }}</label>
                    <input
                        class="form-control"
                        type="file"
                        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                        @change="onFileChange"
                    />
                    <small class="helpText">{{ lang.ect_allowed_formats }}</small>
                    <div class="previewBox" v-if="imagePreview">
                        <img :src="imagePreview" alt="Background preview" class="previewImage" />
                    </div>
                </div>

                <!-- Confirmación explícita de edición -->
                <div class="col-md-12 marginTop text-center actionButtons">
                    <button
                        type="button"
                        class="btn btn-secondary btn-lg"
                        style="width: 110px; border-radius: 20px; margin-right: 10px;"
                        :disabled="isSubmitting"
                        @click="cancelEdit"
                    >
                        {{ lang.ec_cancel }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-success btn-lg"
                        style="width: 110px; border-radius: 20px;"
                        :disabled="isSubmitting"
                    >
                        {{ lang.ect_submit }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Loader from '../../../../../core/components/shared/Loader.vue';
import { mapGetters } from "vuex";
// @ts-ignore
import { Chrome } from "vue-color";

export default {
    name: "editColorTheme",
    components: {
        Loader,
        "chrome-picker": Chrome,
    },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            imageFile: null,
            imagePreview: '',
            bg_template: {
                type: "gradient",
                value: ["rgba(135, 18, 216, 1)", "rgba(22, 25, 78, 1)"],
            },
            lang: {
                ect_color_theme: '',
                ect_bg_type: '',
                ect_color: '',
                ect_gradient: '',
                ect_image: '',
                ect_inactive: '',
                ect_bg_desc: '',
                ect_bg_color: '',
                ect_gradient_1: '',
                ect_gradient_2: '',
                ect_bg_image: '',
                ect_allowed_formats: '',
                ec_cancel: '',
                ect_submit: '',
                ect_invalid_file_title: '',
                ect_invalid_file_text: '',
                ect_fail_load: '',
                ec_fail: '',
                ec_failed_save: '',
            },
        };
    },
    mounted() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
            this.getColorTheme();
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            cardItem: "get_bsite_cardItem",
            langGetter: "lang",
        }),
        colorPicker() {
            return this.parseRGBAString(this.bg_template.value || 'rgba(135, 18, 216, 1)');
        },
        gradientPickerStart() {
            let first = Array.isArray(this.bg_template.value) ? this.bg_template.value[0] : 'rgba(135, 18, 216, 1)';
            return this.parseRGBAString(first);
        },
        gradientPickerEnd() {
            let second = Array.isArray(this.bg_template.value) ? this.bg_template.value[1] : 'rgba(22, 25, 78, 1)';
            return this.parseRGBAString(second);
        },
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        // Aplica preview inmediato sin guardar en backend.
        // Sobrescribe/inyecta bg_template en temp_opts y actualiza el cardItem en store.
        previewTheme() {
            if (!this.cardItem) {
                return;
            }
            let previewItem = JSON.parse(JSON.stringify(this.cardItem));
            if (!Array.isArray(previewItem.temp_opts)) {
                previewItem.temp_opts = [];
            }

            let payload = this.buildPayloadToSave();
            let idx = previewItem.temp_opts.findIndex(opt => {
                return opt.meta_key === 'bg_template' && Number(opt.template_id) === Number(previewItem.template_id);
            });

            if (idx >= 0) {
                previewItem.temp_opts[idx].meta_value = JSON.stringify(payload);
            } else {
                previewItem.temp_opts.push({
                    meta_key: 'bg_template',
                    template_id: previewItem.template_id,
                    meta_value: JSON.stringify(payload),
                });
            }

            this.$store.commit('ModApps/Marketea/refreshPusherItem', previewItem);
        },
        // Factory de valores por defecto para garantizar estructura consistente por tipo.
        defaultThemeByType(type) {
            if (type === 'color') {
                return { type: 'color', value: 'rgba(135, 18, 216, 1)' };
            }
            if (type === 'image') {
                return { type: 'image', value: '' };
            }
            return {
                type: 'gradient',
                value: ['rgba(135, 18, 216, 1)', 'rgba(22, 25, 78, 1)'],
            };
        },
        // Normaliza datos históricos/legados del backend al formato actual:
        // { type: 'color'|'gradient'|'image', value: string|string[] }
        normalizeTheme(data) {
            if (!data || typeof data !== 'object') {
                return this.defaultThemeByType('gradient');
            }
            let type = ['color', 'gradient', 'image'].includes(data.type) ? data.type : 'gradient';
            if (type === 'color') {
                return {
                    type,
                    value: typeof data.value === 'string' && data.value.length > 0 ? data.value : 'rgba(135, 18, 216, 1)',
                };
            }
            if (type === 'image') {
                return {
                    type,
                    value: typeof data.value === 'string' ? data.value : '',
                };
            }
            let gradientValue = data.value;
            if (Array.isArray(gradientValue) && gradientValue.length >= 2) {
                return {
                    type,
                    value: [gradientValue[0], gradientValue[1]],
                };
            }
            if (gradientValue && typeof gradientValue === 'object') {
                let from = gradientValue.from || gradientValue.start;
                let to = gradientValue.to || gradientValue.end;
                if (from && to) {
                    return {
                        type,
                        value: [from, to],
                    };
                }
            }
            return this.defaultThemeByType('gradient');
        },
        // Convierte un string CSS rgba()/rgb() al objeto esperado por vue-color.
        // Si falla el parseo, devuelve un color seguro por defecto.
        parseRGBAString(rgbaString) {
            let regex = /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([0-9]*\.?[0-9]+))?\s*\)/i;
            let match = String(rgbaString || '').match(regex);
            if (!match) {
                return { rgba: { r: 79, g: 164, b: 255, a: 1 } };
            }
            return {
                rgba: {
                    r: Number(match[1]),
                    g: Number(match[2]),
                    b: Number(match[3]),
                    a: typeof match[4] !== 'undefined' ? Number(match[4]) : 1,
                },
            };
        },
        // Convierte respuesta de vue-color a string CSS rgba(r,g,b,a)
        // y limita alpha al rango [0..1].
        toRGBAString(colorPayload) {
            let rgba = colorPayload && colorPayload.rgba ? colorPayload.rgba : colorPayload;
            if (!rgba) {
                return 'rgba(135, 18, 216, 1)';
            }
            let r = Number(rgba.r || 0);
            let g = Number(rgba.g || 0);
            let b = Number(rgba.b || 0);
            let a = typeof rgba.a === 'number' ? rgba.a : Number(rgba.a || 1);
            let alpha = Math.max(0, Math.min(1, a));
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        },
        // Carga configuración actual desde meta_key bg_template.
        // Incluye tolerancia a JSON inválido y normalización de forma.
        async getColorTheme() {
            let t = this;
            t.isLoading = true;
            let getData = {
                // @ts-ignore
                user_id: window.master_client,
                // @ts-ignore
                org_id: window.localorgdata,
                template_id: t.cardItem.template_id,
                id: t.cardItem.id,
                meta_key: 'bg_template',
            };
            // @ts-ignore
            window.master
            .post("getOptionsTemplate", getData)
            .then(r => {
                console.log('getOptionsTemplate', r);
                if (r.data.status) {
                    let parsed = {};
                    try {
                        parsed = JSON.parse((r.data.data && r.data.data.meta_value) || '{}');
                    } catch (e) {
                        parsed = {};
                    }
                    t.bg_template = t.normalizeTheme(parsed);
                    if (t.bg_template.type === 'image' && typeof t.bg_template.value === 'string' && t.bg_template.value) {
                        t.imagePreview = t.bg_template.value;
                    }
                }
                t.isLoading = false;
            })
            .catch(error => {
                console.log(error);
                t.isLoading = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ec_fail,
                    text: this.lang.ect_fail_load,
                    duration: 2000,
                });
            });
        },
        // Resetea estructura cuando cambia el tipo y conserva value en image
        // para no perder referencia ya guardada si el usuario vuelve a ese tipo.
        onTypeChange() {
            let currentType = this.bg_template.type;
            let next = this.defaultThemeByType(currentType);
            if (currentType === 'image' && typeof this.bg_template.value === 'string' && this.bg_template.value) {
                next.value = this.bg_template.value;
            }
            this.bg_template = next;
            if (currentType !== 'image') {
                this.imageFile = null;
                this.imagePreview = '';
            } else if (typeof this.bg_template.value === 'string' && this.bg_template.value && !this.imagePreview) {
                this.imagePreview = this.bg_template.value;
            }
            this.previewTheme();
        },
        // Actualiza el único color en modo color.
        onSingleColorInput(color) {
            this.bg_template.value = this.toRGBAString(color);
            this.previewTheme();
        },
        // Actualiza color inicial del gradiente.
        onGradientStartInput(color) {
            let newValue = Array.isArray(this.bg_template.value) ? [...this.bg_template.value] : this.defaultThemeByType('gradient').value;
            newValue[0] = this.toRGBAString(color);
            this.bg_template.value = newValue;
            this.previewTheme();
        },
        // Actualiza color final del gradiente.
        onGradientEndInput(color) {
            let newValue = Array.isArray(this.bg_template.value) ? [...this.bg_template.value] : this.defaultThemeByType('gradient').value;
            newValue[1] = this.toRGBAString(color);
            this.bg_template.value = newValue;
            this.previewTheme();
        },
        // Validación de archivos:
        // 1) Debe existir archivo.
        // 2) Debe cumplir MIME o extensión permitida (jpg, jpeg, png).
        // 3) Si es válido, se guarda en memoria y se muestra preview local.
        onFileChange(event) {
            let file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
            if (!file) {
                this.imageFile = null;
                return;
            }
            let validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            let extension = (file.name.split('.').pop() || '').toLowerCase();
            if (!validTypes.includes(file.type) && !['jpg', 'jpeg', 'png'].includes(extension)) {
                event.target.value = null;
                this.imageFile = null;
                this.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ect_invalid_file_title,
                    text: this.lang.ect_invalid_file_text,
                    duration: 2500,
                });
                return;
            }
            this.imageFile = file;
            this.imagePreview = URL.createObjectURL(file);
        },
        // Cancelar solo cierra panel lateral sin persistir cambios.
        async cancelEdit() {
            await this.getColorTheme();
            this.previewTheme();
            setTimeout(() => {
                this.$parent.$emit('closed-lateral');
                this.$parent.close();
            }, 300);
        },
        // Método secundario de upload para type=image.
        // Prioridad de estrategia:
        // 1) Evento emitido para que un contenedor externo haga el upload.
        // 2) Método del componente padre uploadBgTemplateImage.
        // 3) Fallback local a endpoint setOptionsTemplate (meta_key bg_template_image).
        // El retorno esperado es string (filename/url/value) para guardarlo luego en bg_template.value.
        async uploadImageBeforeSave() {
            if (!this.imageFile) {
                // Si no hay archivo nuevo, conserva el valor ya existente.
                return this.bg_template.value || '';
            }

            if (this.$listeners && this.$listeners['upload-bg-template-image']) {
                let uploadedValue = await new Promise((resolve, reject) => {
                    this.$emit('upload-bg-template-image', {
                        file: this.imageFile,
                        cardItem: this.cardItem,
                        resolve,
                        reject,
                    });
                });
                return uploadedValue;
            }

            if (this.$parent) {
                // @ts-ignore
                let uploadFn = this.$parent.uploadBgTemplateImage;
                if (typeof uploadFn === 'function') {
                    return await uploadFn(this.imageFile, this.cardItem);
                }
            }

            let formData = new FormData();
            // @ts-ignore
            formData.append("user_id", window.master_client);
            // @ts-ignore
            formData.append("org_id", window.localorgdata);
            formData.append("id", this.cardItem.id);
            formData.append("template_id", this.cardItem.template_id);
            formData.append("meta_key", 'bg_template_image');
            formData.append("bg_image", this.imageFile);
            // @ts-ignore
            formData.append("pusher_id", window.pusher.connection.socket_id);

            // @ts-ignore
            let result = await window.master.post("setOptionsTemplate", formData);
            let payload = result && result.data ? result.data : {};
            if (!payload.status) {
                throw new Error('Image upload failed');
            }

            // Se contemplan formatos de respuesta alternos para robustez ante cambios de API.
            if (payload.value) {
                return payload.value;
            }
            if (payload.filename) {
                return payload.filename;
            }
            if (payload.data && payload.data.value) {
                return payload.data.value;
            }
            if (payload.data && payload.data.filename) {
                return payload.data.filename;
            }
            return this.imageFile.name;
        },
        // Estandariza payload final a persistir según el tipo seleccionado.
        buildPayloadToSave() {
            if (this.bg_template.type === 'color') {
                return {
                    type: 'color',
                    value: String(this.bg_template.value || 'rgba(135, 18, 216, 1)'),
                };
            }
            if (this.bg_template.type === 'gradient') {
                let values = Array.isArray(this.bg_template.value)
                    ? this.bg_template.value
                    : this.defaultThemeByType('gradient').value;
                return {
                    type: 'gradient',
                    value: [String(values[0]), String(values[1])],
                };
            }
            return {
                type: 'image',
                value: String(this.bg_template.value || ''),
            };
        },
        // Flujo principal de submit:
        // 1) Bloquear UI con isSubmitting.
        // 2) Construir payload tipado.
        // 3) Si es image, ejecutar upload secundario y usar su resultado como value.
        // 4) Persistir en meta_key bg_template.
        // 5) Cerrar panel en éxito y notificar en error.
        async submitColorTheme() {
            let t = this;
            t.isSubmitting = true;
            try {
                let payload = t.buildPayloadToSave();
                if (payload.type === 'image') {
                    payload.value = await t.uploadImageBeforeSave();
                    if (!payload.value) {
                        throw new Error('Image is required');
                    }
                }

                let formData = new FormData();
                // @ts-ignore
                formData.append("user_id", window.master_client);
                // @ts-ignore
                formData.append("org_id", window.localorgdata);
                formData.append("id", t.cardItem.id);
                formData.append("template_id", t.cardItem.template_id);
                formData.append("meta_key", 'bg_template');
                formData.append("meta_value", JSON.stringify(payload));
                // @ts-ignore
                formData.append("pusher_id", window.pusher.connection.socket_id);

                await t.$store.dispatch('ModApps/Marketea/setTempOpts', formData);
                t.isSubmitting = false;
                setTimeout(() => {
                    t.$parent.$emit('closed-lateral');
                    t.$modal.hide("modal-editProfile");
                }, 300);
            } catch (error) {
                console.log(error);
                t.isSubmitting = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ec_fail,
                    text: this.lang.ec_failed_save,
                    duration: 2500,
                });
            }
        },
    },
};
</script>
<style scoped lang="scss">
.window-header { cursor: move; }
.marginTop { margin-top: 20px; }
.card-header h4 { font-size: 24px; margin-bottom: 0px; }

.window-body {
    position: relative;
    width: 100%;
    margin: auto;
    height: 500px;
    border: 0px solid #000;
    margin-bottom: 2em;
    overflow: hidden;
    overflow-y: auto;
}

.typeSelector {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.typeOption {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-weight: 600;
}

.picker {
    margin-top: 10px;
}

.helpText {
    display: block;
    margin-top: 8px;
    color: #666;
}

.previewBox {
    margin-top: 12px;
    border: 1px solid #d8d8d8;
    border-radius: 10px;
    padding: 6px;
}

.previewImage {
    width: 100%;
    max-height: 180px;
    object-fit: cover;
    border-radius: 8px;
}

.actionButtons {
    margin-bottom: 15px;
}

@media (max-width: 767px) {
    .window-body {
        height: 100%;
        max-height: 800px;
        padding-bottom: 12em;
    }
    .actionButtons {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
    }
}
</style>
